import { Field } from '@lightspeed/unified-components-helios-theme/react'
import { useT } from '@transifex/react'
import React from 'react'
import { ApiCustomer } from '@vend/types'
import { CustomerSearch } from '../../../../../customer/customer-search'
import { LineItemFulfilmentCustomerHeaderView } from '../LineItemFulfilmentCustomerHeaderView'

export type LineItemFulfilmentAddCustomerViewProps = {
  onAddNewCustomer: (newCustomerName?: string) => void
  onSelectCustomer: (customer: ApiCustomer | null) => void
}

export const LineItemFulfilmentAddCustomerView: React.FC<LineItemFulfilmentAddCustomerViewProps> = ({
  onAddNewCustomer,
  onSelectCustomer,
}: LineItemFulfilmentAddCustomerViewProps) => {
  const t = useT()

  return (
    <div className="uc-base font-general">
      <div className="flex flex-col gap-6">
        <LineItemFulfilmentCustomerHeaderView />
        <Field
          size="small"
          labelSlot={t('Customer', {
            _context: 'Line item fulfilment popover',
          })}
        >
          <CustomerSearch
            placeholder={t('Add a customer', {
              _context: 'Line item fulfilment popover',
            })}
            onAdd={onAddNewCustomer}
            onSelect={onSelectCustomer}
          />
        </Field>
      </div>
    </div>
  )
}
